import { render } from "./BlocoEstrategico.vue?vue&type=template&id=8b8cfdcc&scoped=true"
import script from "./BlocoEstrategico.vue?vue&type=script&lang=js"
export * from "./BlocoEstrategico.vue?vue&type=script&lang=js"

import "./BlocoEstrategico.vue?vue&type=style&index=0&id=8b8cfdcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b8cfdcc"]])

export default __exports__